import {Button, Popover, Space} from "antd";
import React from "react";
import {ExcelSVG, PdfSVG} from "assets";
const ExportModal = props => {
  const {
    closeModal,
    getReportFileByBillExcel,
    getReportFileByItemExcel,
    getReportFileByBillPdf,
    getReportFileByItemPdf,
  } = props;
  const printBill = (
    <Space>
      <Button
        icon={<ExcelSVG height={26} width={26}></ExcelSVG>}
        onClick={getReportFileByBillExcel}
      ></Button>
      <Button
        className="btn-excel"
        style={{
          marginBottom: 4,
        }}
        icon={<PdfSVG height={26} width={26}></PdfSVG>}
        onClick={getReportFileByBillPdf}
      ></Button>
    </Space>
  );
  const printItem = (
    <Space>
      <Button
        icon={<ExcelSVG height={26} width={26}></ExcelSVG>}
        onClick={getReportFileByItemExcel}
      ></Button>
      <Button
        className="btn-excel"
        style={{
          marginBottom: 4,
        }}
        icon={<PdfSVG height={26} width={26}></PdfSVG>}
        onClick={getReportFileByItemPdf}
      ></Button>
    </Space>
  );
  return (
    <Space direction="vertical" style={{width: "100%"}}>
      <Popover placement="bottom" content={printBill}>
        <Button style={{width: "100%"}} type="primary">
          Báo cáo theo hóa đơn
        </Button>
      </Popover>
      <Popover placement="bottom" content={printItem}>
        <Button style={{width: "100%"}} type="primary">
          Báo cáo theo loại thuốc
        </Button>
      </Popover>
    </Space>
  );
};
export default ExportModal;
